// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable-tabs {
  position: relative;
  min-width: 200px;
}
.scrollable-tabs__wrapper {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollable-tabs__wrapper::-webkit-scrollbar {
  display: none;
}
.scrollable-tabs:hover .scrollable-tabs__button {
  display: block;
}
.scrollable-tabs__button {
  display: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.scrollable-tabs__button--left {
  left: 0;
}
.scrollable-tabs__button--right {
  right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/tabs-menu/ScrollableTabs.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EAEA,wBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAIE;EAEI,cAAA;AAHN;AAOE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AALJ;AAOI;EACE,OAAA;AALN;AAQI;EACE,QAAA;AANN","sourcesContent":[".scrollable-tabs {\n  position: relative;\n  min-width: 200px;\n\n  &__wrapper {\n    overflow-x: auto;\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar{\n      display: none;\n    }\n  }\n\n  &:hover {    \n    .scrollable-tabs__button {\n      display: block;\n    }\n  }\n\n  &__button {\n    display: none;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1;\n\n    &--left {\n      left: 0;\n    }\n\n    &--right {\n      right: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
